import { capture, captureFeature } from "src/utils/analytics";

export const trackTourStarted = (tourId: string) => {
  capture("tour_started", { tour_id: tourId });
};

export const trackTourStep = (tourId: string, stepId: string, stepIndex: number) => {
  capture("tour_step", { tour_id: tourId, step_id: stepId, step_index: stepIndex });
};

export const trackTourCompleted = (tourId: string) => {
  capture("tour_completed", { tour_id: tourId });
};

export const trackTourSkipped = (tourId: string, stepIndex: number) => {
  capture("tour_skipped", { tour_id: tourId, step_index: stepIndex });
};

export const trackTourIntentSelected = (
  tourId: string,
  kind: "general" | "intent"
) => {
  captureFeature("tour_intent_selected", { tour_id: tourId, kind });
};
